import {ActionCreator} from 'redux';
import {Dispatch, ThunkAction} from '../../../../../types/actions';
import {snackbarErrorReload} from '../../../snackbarsStack';
import { boardsTemplatesGoogleAnalyticsEvents, TEMPLATES_LOAD_FAIL } from './googleAnalyticsEvents';

export const onLoadTemplatesFail: ActionCreator<ThunkAction> = () => (dispatch: Dispatch) => {
    dispatch(snackbarErrorReload());
    dispatch(boardsTemplatesGoogleAnalyticsEvents(
        TEMPLATES_LOAD_FAIL
    ));
};
